module.exports = __webpack_public_path__ + "static/amazonMusic-fbf0f33482ce27a1666a1bd49158beab.png";